import React, { useEffect, useRef } from 'react';
import { useChat } from '@livekit/components-react';
import ChatMessageLine from './InputLine';

const ChatRoom = ({ isOpen, onClose }) => {
  const { chatMessages } = useChat();
  const chatRef = useRef(null);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [chatMessages]);

  return (
      <div
          className={`
        z-30 bg-white overflow-hidden
        flex flex-col w-full min-h-0 max-h-[45vh] md:h-full md:max-h-[536px] md:min-h-[536px]
        ${isOpen ? 'flex' : 'hidden'} md:flex
      `}
          style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
      >
        {/* Header */}
        <div className="flex justify-end px-4 py-2 md:hidden bg-[#E5D8FF]">
          <button onClick={onClose} className="p-1">
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none">
              <path d="M1.2 12.36C0.92 12.09 0.93 11.64 1.2 11.38L6.2 6.37L1.2 1.37C0.93 1.1 0.93 0.66 1.2 0.38C1.46 0.1 1.92 0.11 2.19 0.38L7.19 5.38L12.19 0.38C12.45 0.11 12.91 0.11 13.18 0.38C13.45 0.65 13.45 1.1 13.18 1.37L8.18 6.37L13.18 11.38C13.45 11.64 13.45 12.09 13.18 12.36C12.91 12.63 12.45 12.62 12.19 12.36L7.19 7.36L2.19 12.36C1.92 12.62 1.47 12.62 1.2 12.36Z" fill="#363645"/>
            </svg>
          </button>
        </div>

        {/* Chat body */}
        <div className="flex flex-col flex-1 min-h-0">
          <div ref={chatRef} className="flex-1 overflow-y-auto bg-[#E5D8FF] p-4 space-y-3">
            {chatMessages.map((msg) => {
              let parsed;
              try {
                parsed = JSON.parse(msg.message);
              } catch (e) {
                parsed = null;
              }

              const name = parsed?.sender || msg.sender?.identity || 'Аноним';
              const text = parsed?.text || msg.message;

              return (
                  <div key={msg.timestamp} className="flex gap-3 text-sm">
                    <div className="rounded-full w-8 h-8 bg-[#6C38CC] shrink-0" />
                    <div>
                      <p className="font-semibold text-[#6C38CC]">{name}</p>
                      <p className="text-[#363645] whitespace-pre-wrap">{text}</p>
                    </div>
                  </div>
              );
            })}
          </div>

          {/* Input line */}
          <div className="bg-[#E5D8FF] px-4 py-2 shrink-0">
            <ChatMessageLine />
          </div>
        </div>
      </div>
  );
};

export default ChatRoom;
